import { BarChart3, Building2, Layers } from "lucide-react";
import { ServiceLanding } from "@/components/ServiceLanding";

const cfg = {
  prefix: "accounting",
  pageTitle: "Accounting Services for Small Businesses | CalCor Solutions, Seattle",
  topbarLabel: "Accounting services · Seattle & remote",
  eyebrow: "Accounting Services",
  heroTitle: (
    <>
      Numbers you can <em className="text-pine">run the business on.</em>
    </>
  ),
  heroSub:
    "CalCor Solutions runs your accounting function — disciplined monthly closes, financial statements your board or lender can rely on, and grant & fund accounting — for one fixed monthly fee. Based in Seattle, serving clients remotely everywhere.",
  formHeading: "Start with a free consultation.",
  formSub: "Two minutes now — books you can trust every month after.",
  messageLabel: "What does your accounting look like today? *",
  formPlaceholder: "e.g. Bookkeeper left, board wants monthly statements, need grant tracking set up…",
  submitLabel: "Get my accounting quote",
  quoteCta: "Get a fixed-fee quote",
  serviceValue: "Accounting",
  audienceHeading: (
    <>
      Built for organizations <em className="text-pine">like yours.</em>
    </>
  ),
  audiences: [
    {
      icon: Building2,
      title: "Small businesses",
      desc: "You need a real accounting function without a full-time hire. We close your books monthly and deliver statements you can act on.",
    },
    {
      icon: BarChart3,
      title: "Growing businesses",
      desc: "Outgrowing bookkeeping-only support? Get budgeting, cash-flow visibility, and reporting that scales with the business.",
    },
    {
      icon: Layers,
      title: "Boards, councils & programs",
      desc: "Fund accounting, grant tracking, and statements your board, council, or auditor can rely on — in plain language.",
    },
  ],
  includedHeading: (
    <>
      Your accounting, <em className="text-pine">handled monthly.</em>
    </>
  ),
  includedSub:
    "One engagement, one fixed fee, and reporting that turns your records into decisions — every single month.",
  included: [
    "Disciplined month-end close",
    "Financial statements: P&L, balance sheet, cash flow",
    "Grant and fund accounting",
    "Payroll and sales tax coordination",
    "Budget support and cash-flow visibility",
    "Board- and lender-ready reporting packages",
    "Fixed monthly fee — no surprise invoices",
    "A CPA-ready package at year-end",
  ],
  testimonialsHeading: (
    <>
      Fifteen years of <em className="text-pine">kept promises.</em>
    </>
  ),
  testimonials: [
    {
      quote: "They answer in plain English, hit every deadline, and our board finally understands the numbers.",
      by: "Executive Director, regional nonprofit",
      where: "Seattle, WA",
    },
    {
      quote: "CalCor untangled two years of messy books in a single quarter. Our lender actually complimented the reporting package.",
      by: "Owner, family-run retail group",
      where: "Tacoma, WA",
    },
    {
      quote: "Every month closes on time, every report makes sense, and tax season stopped being a fire drill.",
      by: "Founder, growing e-commerce business",
      where: "Seattle, WA",
    },
  ],
  finalTitle: (
    <>
      Give your numbers <em className="text-paper/70">a professional home.</em>
    </>
  ),
  finalSub:
    "Tell us where your accounting stands today. You will hear back within one business day with next steps and a fixed monthly fee — no pressure, no jargon.",
};

export default function Accounting() {
  return <ServiceLanding cfg={cfg} />;
}
